export default __webpack_public_path__ + "static/media/ps_12.46bf8945.png";